import { environment } from '../../environments/environment';
const baseUrl = `${environment.apiBaseUrl}api/`;
const baseUrl2 = `${environment.facilityBaseUrl}api/`;
const eventBaseUrl = `${environment.eventBaseUrl}api/`;
const vmsBaseUrl = `${environment.vmsBaseUrl}api/`;
const vegitationBaseUrl = `${environment.apiBaseUrlVegitation}api/`;
const baseUrlNoAth = `${environment.apiBaseUrl}`;
const apiversion = "v1";
const roleBaseUrl = `${environment.apiBaseUrlRole}api/`;

// console.log(baseUrlNoAth);

// const baseUrl2 = `${environment.apiBaseUrl}bp/api/`; /// use only for development

const officebaseUrl = `${environment.apiBaseUrl}`;

export const APIs = {
  // getAuthToken: `${baseUrl}Home/oAuth/token`,
  // getMeetingRoomList:`${baseUrl}Home/resources`,
  // getCredits:`${baseUrl}credit-accounts/stats`
  getOfficeAccessPoints: `${baseUrl}OfficeRnd/resources`,
  saveMeetingRoomDetail: `${baseUrl}MeetingRoom/SaveMeetingRoomDetail`,
  postMeeting: `${baseUrl}Meeting/BookMeeting`,
  getDatabaseCredits: `${baseUrl}Credit/GetCreditList`,
  getMeetingDetail: `${baseUrl}Meeting/GetMeetingDetail`,
  cancelMeeting: `${baseUrl}Meeting/CancelMeeting`,
  saveMeetingInvitees: `${baseUrl}MeetingInvitees/SaveMeetingInvitees`,
  saveMeetingInvitees2: `${baseUrl}MeetingInvitees/SaveMeetingInvitees2`,
  saveExternalMeetingInvitees: `${baseUrl}MeetingInvitees/SaveExternalMeetingInvitee`,
  removeMemberFromMeeting: `${baseUrl}MeetingInvitees/RemoveMeetingInvitee`,
  getMeetingRoomDetail: `${baseUrl}MeetingRoom/GetMeetingRoomDetail`,
  getmeetingInviteesWithExternals: `${baseUrl}MeetingInvitees/meetingInvitees`,
  getApiAuthToken: `${baseUrl}token`,
  getAuthToken: `${baseUrl}OfficeRnd/oAuth/token`,
  getOfficeTeams: `${baseUrl}OfficeRnd/teams`,
  getOfficeMemberships: `${baseUrl}OfficeRnd/memberships`,
  getOfficeMembers: `${baseUrl}OfficeRnd/members`,
  getOfficeContracts: `${officebaseUrl}contracts`,
  getOfficeContractsBaseUrl: `${baseUrl}OfficeRnd/contracts`,

  getMeetingRoomOfficerndList: `${baseUrl}Home/resources`,
  GetMeetingList: `${baseUrl}Meeting/GetMeetingList`,
  getMeetingRoomListDetails: `${baseUrl}MeetingRoom/GetMeetingRoomList`,
  getTimelineData: `${baseUrl}Meeting/GetTimeLineData`,
  getCredits: `${baseUrl}credit-accounts/stats`,
  getDepartmentList: `${baseUrl}Employees/departmentList`,
  getParkiteDepartmentList: `${baseUrl}pms/Employees/GetParkiteDepartmentList`,
  addParkiteCoADmin: `${baseUrl}pms/ParkCLA/Save`,
  updateCLAParkiteCoADmin: `${baseUrl}pms/ParkCLA/Update`,

  getAccessPoint: `${baseUrl}Employees/getAccessPoints`,
  addemployee: `${baseUrl}Employees/addEmployee`,
  updateUserAccessPoint: `${baseUrl}Employees/updateAccessPoint`,
  updateTenantAccessPoint: `${baseUrl}Employees/UpdateTenantAccessPoint`,
  getUserInfo: `${baseUrl}Employees/getUserInfo`,
  getUserDepartmentInfo: `${baseUrl}Employees/getUserDepartmentInfo`,
  resendEmail: `${baseUrl}Employees/resendEmail`,
  getUserAccessPoints: `${baseUrl}Employees/getUserAccessPoints`,
  getSavedAccessPoint: `${baseUrl}Employees/getTenantSavedAccessPoints`,
  getuserSavedAccessPoint: `${baseUrl}Employees/getUserSavedAccessPoints`,
  getRolesList: `${baseUrl}Company/roleList`,
  addorupdateuserRole: `${baseUrl}Company/addorupdateUserRole`,
  addorupdateTenant: `${baseUrl}Company/addorupdateTenant`,
  addorupdateOrgEmployee: `${baseUrl}Company/addorupdateOrgEmployee`,
  gettenantbyUserId: `${baseUrl}Company/GetTenantbyUserId`,
  updateEmployee: `${baseUrl}Company/updateEmployee`,
  deleteAdmin: `${baseUrl}Employees/remove`,
  getCompanyList: `${baseUrl}Company/getCompanyList`,
  updateTenantStatus: `${baseUrl}Company/updateTenantStatus`,
  getTenantIdbyTeamId: `${baseUrl}Company/GetTenantbyTeamId`,
  meetingRoomBlobStorage: `${baseUrl}blobstorage`,
  meetingRoomBlobStorageinsert: `${baseUrl}blobstorage/insertfile`,
  // addUpdateContact: `${baseUrl}Contact`,
  addUpdateContact: `${baseUrl}Contact/UpdateorAddContact`,
  getEmployeeList: `${baseUrl}Employees/GetEmployeeList`,
  getOrganization: `${baseUrl}Credit/GetTenants`,
  sendMemberOnboardingEmail: `${baseUrl}Employees/SendMemberOnboardingEmail`,
  getCreditSpentbyTenant: `${baseUrl}Credit/GetMonthlyCreditSpentByTenantId`,
  sendBulkEmail: `${baseUrl}Employees/bulkEmail`,
  getAdminDetails: `${baseUrl}Token/CheckAdmin`,
  getAdminDetailsWithToken: `${baseUrl}Token/GetTokenForCLA`,
  getEmailid: `${baseUrl}Employee/GetEmployeeList`,
  getMeetingInviteesList: `${baseUrl}MeetingInvitees/GetMeetingInviteesList`,
  addUpdateDomain: `${baseUrl}Company/AddUpdateDomain`,

  getReportMeetingRooms: `${baseUrl}report/meetingrooms`,
  getAccessPoints: `${baseUrl}report/accesspoints`,
  getCheckins: `${baseUrl}report/checkins`,
  getCreditReports: `${baseUrl}report/creditreports`,
  getDepartments: `${baseUrl}report/departments`,
  getEmployees: `${baseUrl}report/employees`,
  getMeetings: `${baseUrl}report/meetings`,
  getMemberships: `${baseUrl}report/memberships`,
  getRfidList: `${baseUrl}report/GetEmployeeMemberCard`,
  getAdmin: `${baseUrl}CLA/GetById`,
  getGstDetails: `${baseUrl}CLA/GetGstDetails`,
  addGstDetails: `${baseUrl}CLA/SaveGstDetails`,
  getCLAParkiteAdmin: `${baseUrl}pms/ParkCLA/GetById`,
  getParkiteAdmin: `${baseUrl}pms/Employees/GetCLAAdminDetailsById`,
  getGetCLACredits: `${baseUrl}Credit/getCLACredits`,
  getclaCredit: `${baseUrl}Credit/getCLACredits`,
  getTenant: `${baseUrl}Credit/GetTenants`,
  getTenantUser: `${baseUrl}Credit/GetMonthlyCreditSpentByTenantId`,
  //getContactsData: `${baseUrl}Contact`,
  getContactsData: `${baseUrl}Contact/GetContactPortal`,
  getCoAdmins: `${baseUrl}CLA/GetCoAdmin`,
  removeUser: `${baseUrl}users/RemoveUser`,
  getTenantCredit: `${baseUrl}Credit/GetCredit`,
  getDayPass: `${baseUrl}OfficeRnd/daypass`,
  parking: `${baseUrl}Parking`,
  addCoADmin: `${baseUrl}CLA/Save`,
  updateCLACoADmin: `${baseUrl}CLA/Update`,
  removeCoADmin: `${baseUrl}CLA/Delete`,
  sendEmails: `${baseUrl}Employees/SendEmailsToMember`,
  getOffBoardingEmail: `${baseUrl}Company/GetOffBoardingTenantAdminEmailContent`,
  updateTenantMemberStatus: `${baseUrl}Employees/updateTenantMemberStatus`,
  changeActivation: `${baseUrl}Employees/UpdateTenantMemberStatus`,
  getTaAdmin: `${baseUrl}Employees/getadmin`,
  saveCoAdmin: `${baseUrl}Employees/SaveAdmin`,
  updateCoAdmin: `${baseUrl}Employees/UpdateAdmin`,
  getOverviewCLA: `${baseUrl}OverView/GetOverviewCLA`,
  getAllNotifications: `${baseUrl}PushNotification/GetCLAPortalNotificationDetails`,
  clearNotification: `${baseUrl}PushNotification/ClearPortalNotification`,
  updateNotification: `${baseUrl}PushNotification/UpdateNotification`,
  //getOffBoardingEmail: `${baseUrl}Company/GetOffBoardingTenantAdminEmailContent`,
  getCLACreditDetails: `${baseUrl}CLACredit/GetCLACreditPoints`,
  RequestCLACreditPoints: `${baseUrl}credit/CLARequestCreditPointsmail`,
  feedbackTenant: `${baseUrl}Feedback/feedbackQuestions`,
  submitFeedback: `${baseUrl}Feedback/feedbackAnswers`,
  getFeedbaktenants: `${baseUrl}Feedback/GetTenants`,
  getFeedbakReport: `${baseUrl}Feedback/feedbackReport`,
  checkFeedbakExist: `${baseUrl}Feedback/CheckUserFeedbackAnswers`,
  getContactInfo: `${baseUrl}Contact`,
  logoutToken: `${baseUrl}Token/Logout`,
  verifyEmailForApp: `${baseUrl}pms/Employees/VerifyEmailForApp`,

  //phase2 overview
  getOverviewDetails: `${baseUrl}pms/OverView/GetOverViewDetails`,

  // phase2 FAQ
  getFaq: `${baseUrl}FAQ/FAQ/GetFaq`,
  getFaqById: `${baseUrl}FAQ/FAQ/GetFaqDetailsById`,
  saveFaq: `${baseUrl}FAQ/FAQ/SaveFaq`,
  deleteFaq: `${baseUrl}FAQ/FAQ/DeleteFaqDetails`,
  editFaq: `${baseUrl}FAQ/FAQ/GetFaqDetailsById`,

  // Phase2 PMS
  getMyCompanyDetails: `${baseUrl}pms/Employees/GetMyCompanyDetails`,
  getParkiteCoAdmin: `${baseUrl}pms/ParkCLA/GetCoAdmin`,
  removeParkiteCoADmin: `${baseUrl}pms/ParkCLA/Delete`,

  //phase 2 Deals
  saveDeal: `${baseUrl}deals/Deals/SaveDeals`,
  getDealCategory: `${baseUrl}deals/Deals/GetDealCategories`,
  getDealDetail: `${baseUrl}​deals​/Deals​/GetDealParks`,
  getDealDetailByCategory: `${baseUrl}deals/Deals/GetDealsListByCategory`,
  getDeals: `${baseUrl}deals/Deals/GetDealsListCLA`,
  getDealHistory: `${baseUrl}deals/Deals/GetDealsHistoryList`,
  deleteDealImg: `${baseUrl}deals/Deals/RemoveDealsImage`,
  getDealParks: `${baseUrl}deals/Deals/GetParksList`,

  // phase2 bulltin

  getBulletin: `${baseUrl}Bulletins/Bulletins/GetBulletinListCLA`,
  getBulletinParks: `${baseUrl}Bulletins/Bulletins/GetDealParks`,
  saveBulletin: `${baseUrl}Bulletins/Bulletins/SaveBulletins`,
  getBulletinDetail: `${baseUrl}Bulletins/Bulletins/GetBulletinListById`,
  removeBulletin: `${baseUrl}Bulletins/Bulletins/RemoveBulletinDetails`,
  setBulletinPriority: `${baseUrl}Bulletins/Bulletins/SetBulletinPriority`,
  getBulletinHistory: `${baseUrl}Bulletins/Bulletins/GetBulletinsHistoryList`,

  // phase2 park-info
  getParkType: `${baseUrl}pms/Park/GetParkTypes`,
  getCity: `${baseUrl}pms/Park/GetCityList`,
  getSIngleCity: `${baseUrl}pms/Park/GetCityParks`,
  saveParkBuilding: `${baseUrl}pms/ParkBuilding/SaveParkbuilding`,
  getParkBuilding: `${baseUrl}pms/Park/GetParkBuildings`,
  saveParkDetails: `${baseUrl}pms/Park/SaveParkDetails`,
  getAmentities: `${baseUrl}pms/Park/GetParkAmenities`,
  deleteBuilding: `${baseUrl}pms/ParkBuilding/DeleteParkBuilding`,
  saveCity: `${baseUrl}pms/Park/UploadCityImage`,
  removeParkImage: `${baseUrl}pms/Park/RemoveParkImage`,

  //Facility
  getFacilityTypeList: `${baseUrl2}Facility/Facility/GetFacilityTypeList`,
  getFaclitiesListByType: `${baseUrl2}Facility/Facility/GetFaclitiesListByType`,
  setFacilityTypeImage: `${baseUrl2}Facility/Facility/SetFacilityTypeImage`,
  deleteFacility: `${baseUrl2}Facility/Facility/DeleteFacility`,
  getFacilityDetails: `${baseUrl2}Facility/Facility/GetFacilityDetails`,
  UpdateFacilityDetail: `${baseUrl2}Facility/Facility/UpdateFacility`,
  CreateFacility: `${baseUrl2}Facility/Facility/CreateFacility`,
  GetFacilityCancellationUnit: `${baseUrl2}Facility/Facility/GetFacilityCancellationUnitsType`,
  GetBookedFacilityList: `${baseUrl2}Facility/FacilityBooking/GetBookedFacilityList`,
  getGSTDetail: `${baseUrl}Shared/GST/GetGSTDetail`,
  disburseDeposit: `${baseUrl2}Facility/FacilityBooking/DisburseSecurityDeposit`,
  cancelFacilityBooking: `${baseUrl2}Facility/FacilityBooking/CancelFacilityBooking`,
  getFacilytyReport: `${baseUrl2}Facility/Facility/GetFacilityReport`, //report
  getFacilytyBookingType: `${baseUrl2}Facility/FacilityBooking/GetBookingType`,
  getFacilytyTimeLineDetails: `${baseUrl2}Facility/Facility/GetFacilityTimeLine`,
  bookFacility: `${baseUrl2}Facility/Facility/CreateFacilityCalendar`,
  updateBookedFacility: `${baseUrl2}Facility/Facility/CreateFacilityCalendar`,
  getAllBlockDates: `${baseUrl2}Facility/Facility/GetAllFacilityCalendarDetails`,
  cancelBlockedFacility: `${baseUrl2}Facility/Facility/CancelFacilityCalendar`,
  getFacilityList: `${baseUrl2}Facility/Facility/GetFaclitiesList`,

  //Reports
  getEmployeesReportData: `${baseUrl}pms/Employees/EmployeeReportCLA`,
  getFireWardenReportData: `${baseUrl}FireWarden/FireWarden/FireWardenReportCLA`,
  getInvitationType: `${vmsBaseUrl}VMS/VMSMasterData/GetInvitationType`,
  getVMSReportData: `${vmsBaseUrl}VMS/VMSReport/VMSCLAReport`,
  getVMSBPReportData: `${vmsBaseUrl}VMS/VMSReport/VMSBridgePlusCLAReport`,
  getEventsCategoryData: `${baseUrl}Events/GetEventsCategory`,
  getEventsReportData: `${eventBaseUrl}Events/Events/GetEventsReportForCLA`,
  getVMSExcelReportData: `${vmsBaseUrl}VMS/VMSReport/DownloadVMSCLA`,

  //phase2 bulkApproval
  getInvitationList: `${vmsBaseUrl}VMS/VMS/GetInvitationListForLandingPage`,
  getInvitationDetail: `${vmsBaseUrl}VMS/VMS/GetInvitationDetails`,
  getHistoryDetails: `${vmsBaseUrl}VMS/VMS/GetVMSInvitationHistory`,
  getInviteCompanyList: `${vmsBaseUrl}VMS/VMSTab/GetCompanyListByPark`,
  approveInvitation: `${vmsBaseUrl}VMS/VMS/BulkInvitationApproval`,
  getVmsInvitationRights: `${vmsBaseUrl}VMS/VMS/GetVMSAccessPendingRequestAndHistoryList`,
  getVmsRequestHistory: `${vmsBaseUrl}VMS/VMS/GetVMSAccessHistory`,
  employeeVmsInvitationRights: `${vmsBaseUrl}VMS/VMS/VMSAccess`,
  approveVmsAccessReqId: `${vmsBaseUrl}VMS/VMS/ApproveVMSAccess`,
  approveVmsAccess: `${vmsBaseUrl}VMS/VMS/ApproveVMSAccessByUserid`,
  getBPHistoryDetails: `${vmsBaseUrl}VMS/VMSBridgePlus/GetVMSBridgePlusInvitationHistory`,
  getBPInvitationList: `${vmsBaseUrl}VMS/VMSBridgePlus/GetBridgePlusInvitationListForLandingPage`,
  getBridgePlusBuildingList: `${vmsBaseUrl}VMS/VMSBridgePlus/GetVMSBridgePlusBuildingList`,
  createVMSforExternalEmp: `${vmsBaseUrl}VMS/VMSBridgePlus/SaveExternalEmployeesForVMS`,
  getVmsMeetingPurpose: `${vmsBaseUrl}VMS/VMSMasterData/GetMeetingPurpose`,

  getCompanyListForHistory: `${baseUrl}pms/Park/GetParkCompanies`,
  GetCompanyListForParticipant: `${baseUrl}pms/Park/GetCompanyListForParticipant`,

  revokeEmployeeRights: `${baseUrl}pms/Employees/RevokeAccess`,
  saveEmployees: `${baseUrl}pms/Employees/SaveEmployee`,
  markAsAdmin: `${baseUrl}pms/Employees/MarkAdmin`,
  revokeAsAdmin: `${baseUrl}pms/Employees/RemoveAdmin`,
  getBuildingByParkId: `${baseUrl}pms/Company/GetBuildingListByPark`,
  getBuildingByParkIdAndTenatID: `${baseUrl}pms/Park/GetParkBuildings`,
  employeeListByFilter: `${baseUrl}pms/Employees/EmployeeDetailsWithFilter`,

  saveEmployeeStatus: `${baseUrl}pms/Employees/SaveEmployeeStatus`,

  saveCompany: `${baseUrl}pms/Company/SaveCompanyDetails`,
  getCompaniesBuilding: `${baseUrl}pms/Company/GetCompanyListByBuilding`,
  getCompaniesByTenantId: `${baseUrl}pms/Company/GetCompanyDetailsByTenantId`,
  changeCompanyStatus: `${baseUrl}pms/Company/RemoveCompany`,
  getParkByClaId: `${baseUrl}pms/Park/GetParkByUserId`,

  changeSecuirtyPassword: `${baseUrl}SecurityGuard/SecurityGuardLogin/ChangeSecurityGuardPassword`,
  getVehicleTypes: `${vmsBaseUrl}VMS/VMSMasterData/GetVehicleType`,
  getInvitationTypes: `${vmsBaseUrl}VMS/VMSMasterData/GetInvitationType`,
  getServicesTypes: `${vmsBaseUrl}VMS/VMSMasterData/GetServiceType`,
  getDocumentTypes: `${vmsBaseUrl}VMS/VMSMasterData/GetDocumentType`,
  getMeetingPurpose: `${vmsBaseUrl}VMS/VMSMasterData/GetMeetingPurpose`,
  GetInviteesDetails: `${vmsBaseUrl}VMS/VMSGuestInvitationEmail/GetInviteesDetailsForWeb`,
  UploadVMSDocuments: `${vmsBaseUrl}VMS/VMSGuestInvitationEmail/UploadVMSDocumentsForWeb`,
  SetGuestVehicleDetails: `${vmsBaseUrl}VMS/VMSGuestInvitationEmail/SetGuestVehicleDetailsForWeb`,
  GetVMSAccessPendingRequestAndHistoryList: `${vmsBaseUrl}VMS/VMS/GetVMSAccessPendingRequestAndHistoryList`,
  EmployeeListBasedonTenant: `${baseUrl}pms/Employees/EmployeeListBasedonTenant`,

  // events

  getEventType: `${eventBaseUrl}Events/Events/GetEventsType`,
  GetEventsCategory: `${eventBaseUrl}Events/Events/GetEventsCategoryType`,
  getEvents: `${eventBaseUrl}Events/Events/EventList`,
  getEventDetailById: `${eventBaseUrl}Events/Events/EventDetailsById`,
  GetEventsImageType: `${eventBaseUrl}Events/Events/GetEventsImageType`,
  GetEventsAttendeeType: `${eventBaseUrl}Events/Events/GetEventsAttendeeType`,
  SaveEvents: `${eventBaseUrl}Events/Events/SaveEvents`,
  GetParticipantListDetails: `${eventBaseUrl}Events/Participation/GetParticipantListDetails`,
  GetGuestList: `${eventBaseUrl}Events/Events/GuestList`,
  GuestApproveReject: `${eventBaseUrl}Events/Events/GuestApproveReject`,
  eventApproval: `${vmsBaseUrl}VMS/VMS/BulkInvitationEventApproval`,
  SaveEventQRScan: `${eventBaseUrl}Events/Events/SaveEventQRScan?qrCode=111&UserId=111`,
  GetParticipantListDetailsByID: `${eventBaseUrl}Events/Participation/GetParticipantListDetailsByID`,
  GuestDetailsByInvitationId: `${eventBaseUrl}Events/Events/GuestDetailsByInvitationId`,
  EventDetailsByID: `${eventBaseUrl}Events/Events/EventDetailsByID`,
  DeleteEvent: `${eventBaseUrl}Events/Events/DeleteEvent`,
  DeleteEventImages: `${eventBaseUrl}Events/Events/DeleteEventImage`,
  DeleteEventGalleryImages: `${eventBaseUrl}Events/Events/DeleteEventGalleryImage`,
  getAtendeeList: `${eventBaseUrl}Events/Participation/GetAttendeeDetails`,
  getEventsReportForBridgePlusCLA: `${eventBaseUrl}Events/Events/GetEventsReportForBridgePlusCLA`,

  saveCategoryEvent: `${eventBaseUrl}Events/Events/SaveCategoryEvent`,
  getCategoryEvent: `${eventBaseUrl}Events/Events/GetEventSubCategory`,
  updateEventCategoryStatus: `${eventBaseUrl}Events/Events/EventCategoryActivation`,
  categoryWiseEvent: `${eventBaseUrl}Events/Events/GetEventDetailsByCategoryId`,
  eventByPark: `${eventBaseUrl}Events/Events/GetEventDetailsByParkId`,
  updateEventStatus: `${eventBaseUrl}Events/Events/EventActivation`,
  getSubCategoryDetails: `${eventBaseUrl}Events/Events/GetEventSubCategoryById`,
  SaveTeamDetails: `${eventBaseUrl}Events/Participation/SaveTeamDetails`,
  GetMemberdetails: `${eventBaseUrl}Events/Participation/GetMemberdetails`,
  GetParticipantListDetailsByTenantID: `${eventBaseUrl}Events/Participation/GetParticipantListDetailsByTenantID`,
  GetCompanyListByPark: `${eventBaseUrl}Events/Events/GetCompanyListByPark`,
  GetParticipantDetailsByEventID: `${eventBaseUrl}Events/Participation/GetParticipantDetailsByEventID`,
  ApproveOrDeniedParticipant: `${eventBaseUrl}Events/Participation/ApproveOrDeniedParticipant`,
  GetEventListByParkId: `${eventBaseUrl}Events/Events/GetEventListByParkId`,
  getRegistredUsers: `${eventBaseUrl}event-registration/registered-users`,
  getDownloadGuestReport: `${eventBaseUrl}Events/Report/GuestList`,
  getDownloadTeamIndividual: `${eventBaseUrl}Events/Report/ParticipantList`,

  //profile

  getProfileDetail: `${baseUrl}pms/Employees/GetParkiteAdminDetails`,
  //payment report
  getPaymentcharge: `${baseUrl}Shared/PaymentReceipt/GetPaymentReportDetails`,
  getPaymentReciept: `${baseUrl}Shared/PaymentReceipt/GetPaymentReceiptReportDetails`,

  //plant and vegitation
  getPlantDetailByIdNoAuth: `${vegitationBaseUrl}Vegetation/GetVegetationDetailsByIdForNoAuth`,
  getAllPlantList: `${vegitationBaseUrl}Vegetation/GetAllVegetation`,
  getAllQrCode: `${vegitationBaseUrl}Vegetation/GetAllQrCode`,
  getSingleQrCode: `${vegitationBaseUrl}Vegetation/GetSingleQrCode`,
  removePlantVegitation: `${vegitationBaseUrl}Vegetation/DeleteVegetation`,
  createPlantVegkitation: `${vegitationBaseUrl}Vegetation/CreateVegetation`,
  updatePlantVegkitation: `${vegitationBaseUrl}Vegetation/UpdateVegetation`,
  bulkUploadFile: `${vegitationBaseUrl}Vegetation/BulkUploadVegetationDetails`,
  getBulkInviteTemplate: `${vegitationBaseUrl}Vegetation/GetBulkVegetationExcelTemplate`,
  getPlantDetailById: `${vegitationBaseUrl}Vegetation/GetVegetationDetailsById`,
  GetVegetationDetailsByParkId: `${vegitationBaseUrl}Vegetation/GetVegetationDetailsByParkId`,

  //Employee
  // tenantMemberCardBulkUpload: `${baseUrl}Employees/tenantmembercardbulkupload`,
  tenantMemberCardBulkUpload: `${baseUrl}Company/MemberCardBulkupload`,
  tenantAssignedMemberCardForTenant: `${baseUrl}Company/TenantCardAllocation`,
  tenantMemebrAllocatedCardCount: `${baseUrl}Company/GetMemberCardCount`,
  tenantWiseCardBulkUpload: `${baseUrl}Company/MemberCardBulkupload`,


  //coupon
  createNewCoupon: `${vegitationBaseUrl}Coupon/CreateCoupon`,
  getAllCouponList: `${vegitationBaseUrl}Coupon/GetAllCoupon`,
  updateNewCoupon: `${vegitationBaseUrl}Coupon/UpdateCoupon`,
  getSingleCouponDetails: `${vegitationBaseUrl}Coupon/GetCouponById`,
  removeCouponData: `${vegitationBaseUrl}Coupon/RemoveCoupon`,
  bulkUploadFileCoupon: `${vegitationBaseUrl}Coupon/BulkUploadCoupon`,

  //survey
  // getCompanyListFromPark: `${baseUrl}pms/Company/GetCompanyListByBuilding`,
  getCompanyListFromPark: `${vegitationBaseUrl}${apiversion}/Survey/GetTenantListByBuildings`,
  getTenantListFromBuilding: `${baseUrl}pms/Company/GetBuildingListByPark`,
  createNewPollAndSurvey: `${vegitationBaseUrl}${apiversion}/Survey/CreateSurvey`,
  getEventsPolls: `${eventBaseUrl}Events/Events/EventList`,
  gelAllPollAndSurvey: `${vegitationBaseUrl}${apiversion}/Survey/GetAllSurvey`,
  getSingleSurveyDetails: `${vegitationBaseUrl}${apiversion}/Survey/GetSurveyById`,
  GetSurveyAttribute: `${vegitationBaseUrl}${apiversion}/Survey/GetSurveyAttribute`,
  updateNewPollAndSurvey: `${vegitationBaseUrl}${apiversion}/Survey/UpdateSurvey`,
  addSurveyQuestion: `${vegitationBaseUrl}${apiversion}/Survey/AddQuestion`,
  getSurveyQuestion: `${vegitationBaseUrl}${apiversion}/Survey/GetSurveyQuestion`,
  removeSurvey: `${vegitationBaseUrl}${apiversion}/Survey/RemoveSurvey`,
  getPollsSurveyStatistics: `${vegitationBaseUrl}${apiversion}/Survey/GetSurveyStatistics`,
  getChartDataByQuestionPolls: `${vegitationBaseUrl}${apiversion}/Survey/GetChartDataByQuestion`,
  sendReminderToNonResponder: `${vegitationBaseUrl}${apiversion}/Survey/SendReminder`,
  getSurveyDashBoardData: `${vegitationBaseUrl}${apiversion}/Survey/GetSurveyOverview`,
  getSurveyReportList: `${vegitationBaseUrl}${apiversion}/Survey/SurveyReport`,
  downloadReportPollsSurvey: `${vegitationBaseUrl}${apiversion}/Survey/GetSurveyReport`,
  getMultiParkBuildingList: `${vegitationBaseUrl}${apiversion}/Survey/GetBuldingListByParks`,

  //customer user service group
  createServiceGroup: `${vegitationBaseUrl}CustomerService/CreateCustomerServiceGroup`,
  mainServiceGroupList: `${vegitationBaseUrl}CustomerService/GetAllCustomerServiceGroups`,
  mainClaUserList: `${vegitationBaseUrl}CustomerService/GetAllMembers`,
  createNewServiceUser: `${vegitationBaseUrl}CustomerService/CreateCustomerServiceGroupUser`,
  serviceUserList: `${vegitationBaseUrl}CustomerService/GetCustomerServiceGroupUsers`,
  removeCustomerServiceUser: `${vegitationBaseUrl}CustomerService/RemoveCustomerServiceUser`,
  getGroupByUserList: `${vegitationBaseUrl}CustomerService/GetMemberByGroupId`,
  removeCustomerFromOneGroup: `${vegitationBaseUrl}CustomerService/RemoveMemberByGroup`,
  getSingleMemberDetails: `${vegitationBaseUrl}CustomerService/GetMemberDetail`,
  updateNewServiceUser: `${vegitationBaseUrl}CustomerService/UpdateMemberGroupAndPark`,
  changeServiceUserGroup: `${vegitationBaseUrl}CustomerService/UpdateMemberGroup`,

  //foodcourt
  createFoodCourtVendor: `${vegitationBaseUrl}${apiversion}/FoodCourt/CreateFoodCourtVendor`,
  // gelAllVendorByPark: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetFoodCourtVendorDetailsByParkId`,
  gelAllVendorByPark: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetFoodCourtVendorDetailsByFoodCourtId`,
  removeVendor: `${vegitationBaseUrl}${apiversion}/FoodCourt/DeleteFoodCourtVendorDetails`,
  removeVendorBulk: `${vegitationBaseUrl}${apiversion}/FoodCourt/BulkDeleteFoodCourtVendor`,
  getVendorDetails: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetFoodCourtVendorDetailsById`,
  foodVendorMarkedClosed: `${vegitationBaseUrl}${apiversion}/FoodCourt/UpdateFoodCourtVendorMarkAsClosed`,
  updateFoodCourtVendor: `${vegitationBaseUrl}${apiversion}/FoodCourt/UpdateFoodCourtVendor`,
  addFoodCourtMenu: `${vegitationBaseUrl}${apiversion}/FoodCourt/CreateFoodCourtVendorMenu`,
  foodCourtMenuList: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetFoodCourtVendorMenuListByVendorId`,
  removeMenu: `${vegitationBaseUrl}${apiversion}/FoodCourt/DeleteFoodCourtMenuDetails`,
  removeMenuBulk: `${vegitationBaseUrl}${apiversion}/FoodCourt/BulkDeleteFoodCourtVendorMenu`,
  foodMenuDetails: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetFoodCourtVendorMenuByMenuId`,
  updateFoodCourtMenu: `${vegitationBaseUrl}${apiversion}/FoodCourt/UpdateFoodCourtVendorMenu`,
  bulkUploadFoodMenuCoupon: `${vegitationBaseUrl}${apiversion}/FoodCourt/FoodCourtVendorMenuBulkUpload`,
  // vendorReviewList: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetReviewsListByVendorIdWithVendorRating`,
  vendorReviewList: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetReviewsListByVendorIdWithVendorRatingWithHide`,
  filterVendorReview: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetReviewsListByVendorIdWithSearch`,
  bulkVendorRemoveFlag: `${vegitationBaseUrl}${apiversion}/FoodCourt/BulkFoodCourtVendorRemoveFlagReview`,
  bulkVendorHideReview: `${vegitationBaseUrl}${apiversion}/FoodCourt/BulkFoodCourtVendorHideReview`,
  singleVendorHideReview: `${vegitationBaseUrl}${apiversion}/FoodCourt/FoodCourtVendorHideReview`,
  bulkVendorUnHideReview: `${vegitationBaseUrl}${apiversion}/FoodCourt/BulkFoodCourtVendorUnHideReview`,
  createFoodCourt: `${vegitationBaseUrl}${apiversion}/FoodCourt/CreateFoodCourt`,
  updateFoodCourt: `${vegitationBaseUrl}${apiversion}/FoodCourt/UpdateFoodCourt`,
  listFoodCourt: `${vegitationBaseUrl}${apiversion}/FoodCourt/GetFoodCourtDetailsByParkId`,
  bulkRemoveFoodCourt: `${vegitationBaseUrl}${apiversion}/FoodCourt/BulkDeleteFoodCourt`,

  //Emergency Info
  saveEmergencyInfo: `${vegitationBaseUrl}${apiversion}/EmergencyInfo/save`,
  updateEmergencyInfo: `${vegitationBaseUrl}${apiversion}/EmergencyInfo/save`,
  getEmergencyInfoList: `${vegitationBaseUrl}${apiversion}/EmergencyInfo/get`,
  removeEmergencyInfoList: `${vegitationBaseUrl}${apiversion}/EmergencyInfo/remove`,
  //role and permission
  getMainModuleList: `${roleBaseUrl}${apiversion}/Module/GetModules`,
  getMainUserRoleList: `${roleBaseUrl}${apiversion}/Permission/GetUserRoles`,
  getMainPermissionTypeList: `${roleBaseUrl}${apiversion}/Permission/GetPermissionType`,
  updateRolePermissionData: `${roleBaseUrl}${apiversion}/Permission/Update`,
  getModuleWiseRolePermission: `${roleBaseUrl}${apiversion}/Permission/GetPermission`,
  getUserList: `${roleBaseUrl}${apiversion}/RoleMapping/GetRoleMapping`,
  addUserRoleMapping: `${roleBaseUrl}${apiversion}/RoleMapping/Add`,
  removeUserRoleMapping: `${roleBaseUrl}${apiversion}/RoleMapping/Remove`,
  permissionByEmployee: `${roleBaseUrl}${apiversion}/RoleMapping/GetPermissionByEmployee`,
  GetPermissionTypeByModule: `${roleBaseUrl}${apiversion}/Permission/GetPermissionTypeByModule`,

  getEtlExcelReportData: `${baseUrl2}Facility/Facility/DownloadFacilityETLReport`,
  //Meeting Room
  saveMeetingRoom: `${roleBaseUrl}${apiversion}/ParkMeetingRoom/SaveMeetingRoom`,
  updateMeetingRoomDetail: `${roleBaseUrl}${apiversion}/ParkMeetingRoom/SaveMeetingRoom`,
  getAllAmenities: `${roleBaseUrl}${apiversion}/MeetingAmenity/GetAllAmenities`,
  listAllParkMeetingRoom: `${roleBaseUrl}${apiversion}/ParkMeetingRoom/GetMeetingRoomByParkId`,
  detailsParkMeetingRoom: `${roleBaseUrl}${apiversion}/ParkMeetingRoom/GetParkMeetingDetails`,
  deleteParkMeetingRoom: `${roleBaseUrl}${apiversion}/ParkMeetingRoom/DeleteMeetingRoom`,
  createParkMeetingRoomCalendar: `${roleBaseUrl}${apiversion}/BookMeeting/AddParkMeetingRoomCalender`,
  getAllBlockDatesMeeting: `${roleBaseUrl}${apiversion}/BookMeeting/GetAllMeetingCalendarDetails`,
  getMeetingRoomTimeLine: `${roleBaseUrl}${apiversion}/BookMeeting/GetMeetingRoomTimeLineForWeb`,
  cancelBookedMeeting: `${roleBaseUrl}${apiversion}/BookMeeting/CancelBookingForPortal`,
  bookedMeetingRoomList: `${roleBaseUrl}${apiversion}/BookMeeting/GetBookedMeetingRoomList`,
  cancelBlockedMeeting: `${roleBaseUrl}${apiversion}/BookMeeting/CancelMeetingRoomCalendar`,
  getMeetingRoomReportData: `${roleBaseUrl}${apiversion}/ParkMeetingRoom/GetMeetingRoomReport`,
  getMeetingRoomExcelReportData: `${roleBaseUrl}${apiversion}/ParkMeetingRoom/DownloadCLAReport`,

  regenerateTenantSecurityPassword: `${baseUrl}pms/Company/RegenerateTenantSecurityPassword`,
};

export const LoaderExcludes = [
  'GetCLAPortalNotificationDetails',
  'ClearPortalNotification',
  'UpdateNotification',
  'Contact',
];
